import { type FC, type ReactNode } from "react";

import { cx } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

import { Card, CardTitle } from "../../../../layout/components";
import { Flexbox } from "../../../../shared/components";

import { lensEditDetailsRowFullWidth, lensEditDetailsRowTitle } from "./LensEditDetails.styles";

interface LensDetailsRowProps {
    dataTestId: string;
    title?: ReactNode;
    children: ReactNode;
}

export const LensDetailsRow: FC<LensDetailsRowProps> = ({ dataTestId, title, children }) => {
    return (
        <Card data-testid={dataTestId} className={cx(lensEditDetailsRowFullWidth)}>
            <Flexbox flexDirection="column" gap={title ? `${Spacing.LG}px` : undefined}>
                {title && <CardTitle className={lensEditDetailsRowTitle}>{title}</CardTitle>}
                {children}
            </Flexbox>
        </Card>
    );
};
